export const PREMIUM_FEATURES = Object.freeze({
  customBranding: Object.freeze({
    label: "Complete and Beyond",
    description: "Custom survey branding is included with Complete and Beyond.",
  }),
  customRouting: Object.freeze({
    label: "Beyond only",
    description: "Custom authentication and application routing is included with Beyond only.",
  }),
});

export const featureIncluded = (usage, feature) =>
  Boolean(usage?.features?.[feature]);

